// extracted by mini-css-extract-plugin
export var container = "styles-module--container--L2ISR";
export var external = "styles-module--external--qZf6X";
export var internal = "styles-module--internal--9TmJM";
export var isWhite = "styles-module--isWhite--SsYex";
export var menuPrinicipal = "styles-module--menuPrinicipal--MnBio";
export var separacion = "styles-module--separacion---M58H";
export var separacionArea = "styles-module--separacionArea--Z7lAR";